import { Tooltip } from './Tooltip';
const TableBien = ({ label = '',
    typeBien2 = '',
    typeBien3 = '',
    valueTypeBien2 = '',
    valueTypeBien3 = '',
    onChange = () => { }

}: ITableBienProps) => {
    return (
        <>
            <div className="lbl-input-ihcr mt-20 mb-5">
                {label}
            </div>
            <table className='table-ih-cr'>
                <thead>
                    <tr>
                        <th className='w50' style={{ height: '25px' }}>Tipo de bien</th>
                        <th className='w50'>
                            <div className='img-ihcr'>
                                Suma asegurada
                                <Tooltip id={'tooltipSumaAsegurada'} title='Suma asegurada' text='Agregar el valor de su bien y contenido' />
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div className='text-left display-flex'>
                                Edificio
                                <Tooltip id={'tooltip1'} title='Edificio' text='Casa o apartamento que se utilice como viviendo particular.' />
                            </div>
                        </td>
                        <td className='p-0'>
                            <input
                                name={typeBien2}
                                type='number'
                                value={valueTypeBien2}
                                required={true}
                                onChange={onChange}
                                className='input-field-table-ihcr'
                                autoComplete='off'
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className='text-left display-flex'>
                                Contenido
                                <Tooltip id={'tooltip2'} title='Contenido' text='Muebles o enseres propios y de uso común que tenemos en nuestra vivienda.' />
                            </div>
                        </td>
                        <td className='p-0'>
                            <input
                                name={typeBien3}
                                type='number'
                                value={valueTypeBien3}
                                required={true}
                                onChange={onChange}
                                className='input-field-table-ihcr'
                                autoComplete='off'
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}

export { TableBien };